/* unplugin-vue-components disabled */import { render } from "./collection.vue?vue&type=template&id=5aca1268&scoped=true"
import script from "./collection.vue?vue&type=script&lang=js"
export * from "./collection.vue?vue&type=script&lang=js"

import "./collection.vue?vue&type=style&index=0&id=5aca1268&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aca1268"]])

export default __exports__